export const FormRegistrationEmailTranslationsCs = {
  email: 'Email',
  password: 'Heslo',
  registration: 'Registrovat',
  privacyPolicyText: 'Kliknutím na Registrovat souhlasíte s',
  privacyPolicyLinkText: 'Podmínkami ochrany osobních údajů',

  // errors
  'Required field': 'Povinné pole',
  'Enter a valid email address': 'Zadejte platnou e-mailovou adresu',
  'Password must be at least 8 characters':
    'Heslo musí obsahovat alespoň 8 znaků',
  'Password must be less than 32 characters':
    'Heslo musí mít méně než 32 znaků',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Heslo musí obsahovat alespoň 8 latinských znaků, jedno velké písmeno a jednu číslici',

  // errors back-end
  'Email in use': 'Email je již používán.',
};
